module.exports = __webpack_public_path__ + "img/47.d2f77729.jpg";